import styled from "styled-components";

export const HeaderCss = styled.header`
  position: fixed;
  top: 0;
  width: 100%;
  background: #77e7ff;
  z-index: 1000;

  .header-inner {
	max-width: 1440px;
	margin: 0 auto;
    height: 78px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;
  }

  .logo {
    height: 34px;
  }

  /* =========================
     DESKTOP NAV
  ========================== */

  .nav-desktop {
    display: flex;
    gap: 40px;
  }

  .nav-desktop a {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #ff3b2f;
    font-size: 20px;
    text-decoration: none;
    position: relative;
    transition: 0.2s ease;
  }

  .nav-desktop a:hover {
    opacity: 0.85;
	font-weight: 500
  }

  .nav-desktop img {
    width: 12px;
	transition: transform 0.6s ease;
  }

  .nav-desktop a:hover img {
	 transform: rotate(360deg) scale(1.1);
  }

  /* =========================
     RIGHT SIDE
  ========================== */

  .right-area {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  /* =========================
     LANGUAGE SWITCH (PT | EN)
  ========================== */

  .lang-switch {
    display: flex;
    align-items: center;
    gap: 10px;
	
  }

  .lang-btn {
    background: transparent;
    border: none;
    cursor: pointer;
    color: #ff3b2f;
    font-size: 16px;
    letter-spacing: 0.08em;
    padding: 6px 2px;
    position: relative;
	font-weight: 700;
  }

  .lang-btn::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -4px;
    width: 0%;
    height: 2px;
    background: #ff3b2f;
    transition: width 0.2s ease;
  }

  .lang-btn:hover::after {
    width: 100%;
  }

  .lang-btn.active::after {
    width: 100%;
  }

  .lang-sep {
    color: rgba(255, 59, 47, 0.7);
    font-size: 14px;
  }

  /* =========================
     HAMBURGER
  ========================== */

  .hamburger {
    display: none;
    flex-direction: column;
    gap: 4px;
    background: none;
    border: none;
    cursor: pointer;
  }

  .hamburger span {
    width: 22px;
    height: 2px;
    background: #ff3b2f;
    transition: 0.3s ease;
  }

  .hamburger.open span:nth-child(1) {
    transform: rotate(45deg) translateY(6px);
  }

  .hamburger.open span:nth-child(2) {
    opacity: 0;
  }

  .hamburger.open span:nth-child(3) {
    transform: rotate(-45deg) translateY(-6px);
  }

  /* =========================
     MOBILE MENU
  ========================== */

  .mobile-menu {
    position: fixed;
    inset: 0;
    background: #77e7ff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 30px;
    transform: translateY(-100%);
    transition: 0.3s ease;
    z-index: 999;
  }

  .mobile-menu.show {
    transform: translateY(0);
  }

  .mobile-menu a {
    font-size:40px;
    color: #ff3b2f;
    display: flex;
    gap: 12px;
    text-decoration: none;
    transition: 0.2s ease;

	img{
		max-width:30px
	}
  }

  .mobile-menu a:hover {
    opacity: 0.85;
  }

  .mobile-lang {
    margin-top: 30px;
    display: flex;
    gap: 10px;
    align-items: center;
  }

  /* =========================
     RESPONSIVO
  ========================== */

  @media (max-width: 900px) {
    .nav-desktop {
      display: none;
    }

    .hamburger {
      display: flex;
    }

    .lang-switch {
      display: none;
    }

    .header-inner {
      padding: 0 20px;
      height: 70px;
    }
  }
`;